<template>
  <div id="">
    <header>
      <!--<NavBar class="navbar_always_see"/>-->
    </header>
    <main>
      <!--<CarouselPage/>-->

      <!--<ServicesPage/>-->

      <!--
      <MisionPage/>
      -->

      <ContactPage/>

      <!--
      <FooterPage/>
      -->
    </main>

  </div>
</template>

<script>
//import CarouselPage from './components/CarouselPage.vue'
//import NavBar from './components/navbar/NavBar.vue'
//import ServicesPage from './components/services/ServicesPage.vue'
//import MisionPage from './components/mision/MisionPage.vue'
import ContactPage from './components/contact/ContactPage.vue'
//import FooterPage from './components/footer/FooterPage.vue'

import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init();

export default {
  name: 'App',
  components: {
    //CarouselPage,
    //NavBar,
    //ServicesPage,
    //MisionPage,
    ContactPage,
    //FooterPage
  },
  methods:{
    handleScroll() {
      const enlaces = document.querySelectorAll('.enlace');
      const secciones = document.querySelectorAll('section');

      const posicionScroll = window.scrollY + (window.innerHeight / 2);

      for (let i = 0; i < secciones.length; i++) {
        const posicionSeccion = secciones[i].offsetTop;

        if (posicionScroll >= posicionSeccion) {
          for (let j = 0; j < enlaces.length; j++) {
            enlaces[j].classList.remove('active');
          }
          enlaces[i].classList.add('active');
        }
      }
    }
  },
  mounted() {
    //window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    //window.removeEventListener('scroll', this.handleScroll);
  },
}
</script>

<style>

</style>
